import { useEffect, useState } from 'react';
import { Link,useNavigate, useParams } from 'react-router-dom';

import config from '@/config';
import BoardCardTWO from '@/shared-components/forms/add-board-content/shared-components/BoardCardTWO';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import Loader from '@/shared-components/loader/Loader';
import StaticSeoHead from '@/shared-components/seo/StaticSeoHead';
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

import './NewspaperCategoryPageTWO.css';

export default function NewspaperCategoryPageTWO() {
  const { collection_url } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [collection, setCollection] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${config.apis.api.url}/newspaper/collection/${collection_url}`);
        const json = await res.json();
        setCollection(json);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [collection_url]);

  if (loading) {
    return (
      <div className="newspaper-category-two__loading">
        <Loader thin />
      </div>
    );
  }

  if (!collection) {
    return <p>Sorry, that category wasn’t found.</p>;
  }

  const items = collection.collection_polls || collection.collection_quizzes || [];

  return (
    <>
      <StaticSeoHead
        title={`${collection.collection_name} | Suarte Newspaper`}
        description={collection.collection_description || `Explore ${collection.collection_name} on Suarte Newspaper.`}
        canonicalPath={`/newspaper/pq/${collection_url}`}
        pageType="CollectionPage"
        breadcrumbItems={[
          { name: 'Home', url: 'https://suarte.art/' },
          { name: 'Newspaper', url: 'https://suarte.art/newspaper' },
          { name: collection.collection_name, url: `https://suarte.art/newspaper/pq/${collection_url}` },
        ]}
      />
      <AppNavigationPage>
        <div className="newspaper-category-two__container">
          <header className="newspaper-category-two__header">
            <BackArrowIcon
              className="newspaper-category-two__back-icon"
              onClick={() => navigate(-1)}
            />
            <h1>{collection.collection_name}</h1>
          </header>

          <section className="newspaper-category-two__list">
            {items.map(item => (
              <Link
                key={item._id}
                to={`/article/${item._id}`}
                className="no-underline"
              >
                <BoardCardTWO item={item} showQuestion />
              </Link>
            ))}
          </section>
        </div>
      </AppNavigationPage>
    </>
  );
}
